module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-login-guide"
  }, [_c('div', {
    staticClass: "guide-shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-wrap"
  }, [_c('div', {
    staticClass: "user-info-wrap"
  }, [_c('img', {
    staticClass: "user-icon",
    attrs: {
      "src": _vm.hotelIdUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-info-content"
  }, [_c('p', [_vm._v(_vm._s(_vm.userInfo.type === 3 || _vm.userInfo.type === 6 ? '商户号' : '集团号'))]), _vm._v(" "), _c('p', {
    staticClass: "user-hotel-id"
  }, [_vm._v(_vm._s(_vm.userInfo.type === 3 || _vm.userInfo.type === 6 ? _vm.userInfo.hotelId : _vm.userInfo.belongId))])])]), _vm._v(" "), _c('img', {
    staticClass: "guide-arrow",
    attrs: {
      "src": _vm.arrow
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "login-demo",
    attrs: {
      "src": _vm.login_demo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "guide-content"
  }, [_c('p', [_vm._v("您的" + _vm._s(_vm.userInfo.type === 3 || _vm.userInfo.type === 6 ? '商户号' : '集团号') + "："), _c('span', {
    staticClass: "user-belongId"
  }, [_vm._v(_vm._s(_vm.userInfo.type === 3 || _vm.userInfo.type === 6 ? _vm.userInfo.hotelId : _vm.userInfo.belongId))])]), _vm._v(" "), _c('p', [_vm._v("目前的登录地址完成过渡期后将会下线，")]), _vm._v(" "), _c('p', [_vm._v("请通过新地址e.passiontec.cn重新登录。")])]), _vm._v(" "), _c('div', {
    staticClass: "login-button",
    on: {
      "click": _vm.toLogin
    }
  }, [_c('div', {
    staticClass: "re-login"
  }, [_vm._v("马上登录")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ef102d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/LoginGuide/LoginGuide.vue
// module id = 182
// module chunks = 0